import React from 'react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { RCAlertBox } from '@reverbdotcom/cadence/components';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';

function GiftCardsUnderConstruction() {
  return (
    <div className="mt-2 mb-2">
      <RCAlertBox
        type="warning"
        headerText={<Translate text="discovery.giftCardsUnderConstruction.unavailableTitle" />}
      >
        <Translate
          tag="p"
          text="discovery.giftCardsUnderConstruction.unavailableMessageHtml"
        >
          <CoreLink to="https://reverb.com/news/last-minute-gifts-musicians-will-actually-love">
            <Translate text="discovery.giftCardsUnderConstruction.giftIdeasLinkText" />
          </CoreLink>
        </Translate>
      </RCAlertBox>

      <div className="mt-2">
        <RCAlertBox
          type="info"
          headerText={<Translate text="discovery.giftCardsUnderConstruction.redeemTitle" />}
        >
          <Translate
            tag="p"
            text="discovery.giftCardsUnderConstruction.redeemHtml"
          >
            <CoreLink to="/redeem">
              <Translate text="discovery.giftCardsUnderConstruction.redeemLinkText" />
            </CoreLink>
          </Translate>
        </RCAlertBox>
      </div>
    </div>
  );
}

export default GiftCardsUnderConstruction;
